import { render, staticRenderFns } from "./OrgChartDiagram.vue?vue&type=template&id=175b8904"
import script from "./OrgChartDiagram.vue?vue&type=script&lang=js"
export * from "./OrgChartDiagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('175b8904')) {
      api.createRecord('175b8904', component.options)
    } else {
      api.reload('175b8904', component.options)
    }
    module.hot.accept("./OrgChartDiagram.vue?vue&type=template&id=175b8904", function () {
      api.rerender('175b8904', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/OrgChart/OrgChartDiagram.vue"
export default component.exports